<template>
<div></div>
  <!-- Footer -->
  <!--
  <footer class="sticky-footer bg-white">
    <div class="container my-auto">
      <div class="copyright text-center my-auto">
        <span>Copyright &copy; Your Website 2019</span>
      </div>
    </div>
  </footer>
  -->
  <!-- End of Footer -->
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>